import React from 'react';
import { Link } from 'react-router-dom';
import { config } from '../pages/config';
import { getCourseDurationBadge } from '../pages/Courses/courseFilterUtils';
import { getCourseSlug } from '../pages/Courses/courseSlugs';
import {
  FallbackImage,
  getCourseImageCropStyle,
  getCourseImageObjectPosition,
  getCourseImageSrc,
} from '../pages/Courses/courseImages';

const CourseCard = ({ course }) => {
  const durationBadge = getCourseDurationBadge(course);
  const imageSrc = getCourseImageSrc(course, config.imageUrl);
  const cropStyle = getCourseImageCropStyle(course);
  const imageStyle = cropStyle || { objectPosition: getCourseImageObjectPosition(course) };
  const hasTheory = Number(course.theory) > 0;

  return (
    <div className="course-tile">
      <div className="course-tile-media">
        <img
          src={imageSrc}
          alt={course.title}
          style={imageStyle}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = FallbackImage;
          }}
        />
        {durationBadge && (
          <span className="course-tile-badge">{durationBadge}</span>
        )}
      </div>
      <div className="course-tile-body">
        <h4 className="course-tile-title">{course.title}</h4>
        <div className="course-tile-price">
          <span className="symble">£</span>
          {course.price}
        </div>
        <ul className="course-tile-features">
          <li>
            <i className="bi bi-check-circle-fill"></i>
            {course.practical} Hours Practical Driving
          </li>
          <li>
            <i className="bi bi-check-circle-fill"></i>
            {hasTheory
              ? `${course.theory} Hours Theory`
              : 'Qualified DVSA-Approved Instructor'}
          </li>
        </ul>
        <div className="course-tile-actions">
          <Link
            to={`${config.appUrl}courses/${getCourseSlug(course)}`}
            className="btn-view-details"
          >
            View Details
          </Link>
          <Link to={`${config.appUrl}book-a-lesson`} className="btn-book-now">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
